import PatFail from "../../../../football/rules/offensive/pat/pat-fail";
export default class FlagPatFail extends PatFail {
    switchPossession(gameContext) {
        gameContext.switchPossession();
    }
}
